import LoginForm from "../../components/Unique/Login/login_form";
import logo from "../../components/Assets/denda white.png";
import "../../pages/Home/home.css";

function LoginPage() {
  return (
    <div className="login-page">
      <div className="login-logo">
        <img src={logo} alt="Logo" className="logo" /> {/* Display company logo */}
      </div>

      <div className="login-container">
        <h4 className="log-in"> Log In </h4>
        <div className="login-form">
          <LoginForm /> {/* Render LoginForm component */}
        </div>
      </div>

      <div className="denda">
        <h2> Denda </h2>
      </div>
    </div>
  );
}

export default LoginPage;
